// Package imports:
import React from 'react';
// Component imports:
import DisplayBox from '../../../ui-elements/DisplayBox/DisplayBox';
import Input from '../../../ui-elements/Input/Input';
import Radio from '../../../ui-elements/Radio/Radio';
import Checkbox from '../../../ui-elements/Input/Checkbox';
import Button from '../../../ui-elements/Button/Button';

const IndividualKYCExample: React.FC = () => {
    return (
        <div className="kyc-example">
            <h1>Áreiðanleikakönnun</h1>
            <div className="KCL_company-title">
                <div className="info-col">
                    <div className="info-item">
                        <span className="title">
                            Nafn
                        </span>
                        <span className="value">
                            Kelda Kóðadóttir
                        </span>
                    </div>
                </div>
                <div className="info-col">
                    <div className="info-item">
                        <span className="title">
                            Kennitala
                        </span>
                        <span className="value">
                            091079-1239
                        </span>
                    </div>
                </div>
                <div className="info-col">
                    <div className="info-item">
                        <span className="title">
                            Póstfang
                        </span>
                        <span className="value">
                            Kelduvogur 20, Reykjavík
                        </span>
                    </div>
                </div>
            </div>
            <DisplayBox displayBoxSize="xl" grayBackground>
                <ol className="kyc-questions">
                    <li>
                        <p className="paragraph--bold">
                            Hvert er lögheimili þitt?
                        </p>
                        <p className="paragraph-small">
                            Vinsamlega tilgreinið heimilisfang og póstnúmer.
                        </p>
                        <Input
                            label="Heimilisfang"
                            inputSize="lg"
                            disabled
                        />
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Er skattaleg heimilisfesti þín á Íslandi?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => {}}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => {}}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Stundar þú viðskipti með mikið reiðufé?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => {}}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => {}}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Tilgangur viðskiptasambands
                        </p>
                        <p className="paragraph-small">
                            Hver er tilgangur fyrirhugaðra viðskipta, það er þjónustu sem þú munt nýta þér hjá Þjónustuaðila?
                        </p>
                        <Input
                            label="Tilgangur viðskiptasambands"
                            inputSize="lg"
                            disabled
                        />
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Raunverulegur eigandi
                        </p>
                        <p className="paragraph-small">
                            Ert þú eigandi þeirra fjármuna sem notaðir eru í viðskiptasambandinu?
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => {}}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => {}}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Uppruni fjármuna
                        </p>
                        <p className="paragraph-small">
                            Tilgreindu uppruna þeirra fjármuna sem notaðir eru í viðskiptasambandinu.
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="opt1" name="opt1" value="opt1" defaultValue="" onChange={() => {}}>Fjármagnstekjur, laun</Radio>
                                </li>
                                <li>
                                    <Radio id="opt2" name="opt2" value="opt2" defaultValue="" onChange={() => {}}>Lántaka</Radio>
                                </li>
                                <li>
                                    <Radio id="opt3" name="opt3" value="opt3" defaultValue="" onChange={() => {}}>Arfur</Radio>
                                </li>
                                <li>
                                    <Radio id="opt4" name="opt4" value="opt4" defaultValue="" onChange={() => {}}>Annað</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                    <li>
                        <p className="paragraph--bold">
                            Ert þú í áhættuhópi vegna stjórnmálalegra tengsla?
                        </p>
                        <p className="paragraph-small">
                            Til einstaklinga í áhættuhópi vegna stjórnmálalegra tengsla teljast þeir einstaklingar, innlendir og erlendir, sem eru eða hafa verið háttsettir í opinberri þjónustu, ásamt nánustu fjölskyldu þeirra og nánum samstarfsmönnum.
                        </p>
                        <div className="radios-group">
                            <ul>
                                <li>
                                    <Radio id="yes" name="yes" value="yes" defaultValue="" onChange={() => {}}>Já</Radio>
                                </li>
                                <li>
                                    <Radio id="no" name="no" value="no" defaultValue="" onChange={() => {}}>Nei</Radio>
                                </li>
                            </ul>
                        </div>
                    </li>
                </ol>
                <div className="confirm-info">
                    <p className="paragraph--bold">
                        Staðfesting á réttum upplýsingum
                    </p>
                    <p className="paragraph-small">
                        Ég staðfesti að þær upplýsingar sem ég hef veitt hér að ofan séu réttar eftir minni bestu vitund og skuldbind mig til að tilkynna Þjónustuaðila skriflega um breytingar á þeim eins fljótt og mögulegt er.
                    </p>
                    <Checkbox
                        label="Ég samþykki"
                        disabled
                    />
                </div>
                <div className="actions">
                    <Button
                        buttonType="secondary"
                        size="lg"
                    >
                        Hætta við
                    </Button>
                    <Button
                        buttonType="primary"
                        size="lg"
                    >
                        Staðfesta
                    </Button>
                </div>
            </DisplayBox>
        </div>
    );
}

export default IndividualKYCExample;